import {Model} from './model';
import {ReportingManager, Scheme} from '../services/sp-reporting/reporting-manager.service';
import {DashboardShared} from "./dashboard-shared";
import {NamedItem} from '../pipes/array-name-join.pipe';

export class Dashboard implements Model, NamedItem {
  id: number;
  name: string;
  preset?: boolean;
  description?: string; // Description must be defined if preset is set
  image?: string; // Base64 of chosen image
  _shared?: boolean; // View only helper data
  user_id: number;
  scheme: Scheme;
  created_at: Date;

  constructor() {
    //const defaultLink: Link = {id: LinkUtils.getNextLinkId(), active: true, name: "Default"}
    this.scheme = {specs: [], links: [], version: ReportingManager.CHART_SAVE_VERSION};
  }

  static fromShared(shared: DashboardShared): Dashboard {
    const dash = new Dashboard();
    dash.id = -1;
    dash.name = shared.content.data.name ? shared.content.data.name : "Shared Dashboard"; // Compatibility purpose
    dash.preset = false;
    dash.user_id = -1;
    dash.scheme = shared.content.scheme;
    dash.created_at = new Date();

    return dash;
  }
}
